import type { MDXComponents } from "mdx/types";

/* Global element mapping for rendered .mdx bodies — themed to the shell's
   token ramp so menu content can be written as plain markdown. */
const components = {
  h3: ({ children }) => (
    <h3 className="px-3 pt-4 pb-1 text-micro font-semibold tracking-[0.14em] text-fg-faint uppercase">
      {children}
    </h3>
  ),
  p: ({ children }) => (
    <p className="px-2 py-1 text-note text-fg-dim">{children}</p>
  ),
  strong: ({ children }) => (
    <strong className="font-semibold text-fg">{children}</strong>
  ),
  ul: ({ children }) => <ul className="space-y-0.5">{children}</ul>,
} satisfies MDXComponents;

export function useMDXComponents(): MDXComponents {
  return components;
}
